import script from "./PrevItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrevItem.vue?vue&type=script&lang=ts&setup=true"

import "./PrevItem.vue?vue&type=style&index=0&id=4cd2aa5d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd2aa5d"]])

export default __exports__